<template>
  <div id="app" class="mt-16 ml-6" align="center">
    <router-link to="/">
        <v-img 
        src="../assets/InTheSuburbs-small.png"
        href="/"
        max-width="350"
        alt="InTheSuburbs.com.au"
      ></v-img>
      </router-link>
    <br>
    <br>
    <br>
    <h2>List of all suburbs in this site</h2>
    <br>
    <br>
    <br>
    <div v-for="subs in suburbsList" :key="subs">
      <a :href="'/suburb?name='+subs.replace(/\s+/g, '+')" >{{ subs }}</a>
      <br>
      <br>
    </div>
    <br>
    <br>
    <br>
    <br>
  </div>
</template>

<script>
  import suburbsList from '../assets/suburbs_min.json'

  export default {
    name: 'Index',

    data () {
      return {
        pageTitle: '',
        pageMeta: [],
        suburbsList
      }
    },

  mounted() {
    this.pageTitle = "InTheSuburbs.com.au - Your source of information about Australian suburbs",
    this.pageMeta = [
                    {
                        name: 'description',
                        content: 'List of Australian suburbs in the site.'
                    },
                    {
                        property: 'og:description',
                        content: 'List of Australian suburbs in the site.'
                    },
                    {
                        property: 'og:type',
                        content: 'website'
                    },
                    {
                        property: 'og:title',
                        content: 'List of Australian suburbs in the site.'
                    }
                   ]
  },
  }
</script>
